type ValidationRegexsKeys =
    | 'persianArabicCharacters'
    | 'persianCharactersAndLatinNumbers'
    | 'onlyNumbers'
    | 'emailValidation'
    | 'sheba'
    | 'baseMobileNumber'
    | 'basePostalCode'
    | 'foreignerCode'

export const ValidationRegexs: Record<ValidationRegexsKeys, RegExp> = {
    persianArabicCharacters: /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FF\u200C\u200B\s]+$/, // persian + arabic + space + semi-space
    persianCharactersAndLatinNumbers: /^[\u0600-\u06FF\u200C\u200B0-9\s.؟!،?]+$/,
    onlyNumbers: /[0-9\u06F0-\u06F9\u0660-\u0669]+/,
    emailValidation: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
    sheba: /^\p{N}{2}(\p{N}{3})\p{N}{19}$/u,
    baseMobileNumber: /^09\d{9}$/,
    basePostalCode: /^\p{N}{10}$/u,
    foreignerCode: /^\d{12}$/,
}
